// ─────────────────────────────────────────
//  BOARD THEMES
// ─────────────────────────────────────────

export const BOARD_THEMES = {
  classic: { id:"classic", name:"Classic",  light:"#F0D9B5", dark:"#B58863", selected:"#F6F669", lastLight:"#CDD16E", lastDark:"#AABE51",  price:0, unlocked:true },
  marble:  { id:"marble",  name:"Marble",   light:"#E8E0D8", dark:"#8B7B6B", selected:"#FFD700", lastLight:"#BDD68E", lastDark:"#9DC06E",  price:0, unlocked:true },
  ocean:   { id:"ocean",   name:"Ocean",    light:"#C5DCE8", dark:"#4A7A9B", selected:"#FFE680", lastLight:"#A8D8A8", lastDark:"#78B878",  price:0, unlocked:true },
  night:   { id:"night",   name:"Night",    light:"#4A4A5A", dark:"#2A2A3A", selected:"#FFD700", lastLight:"#667766", lastDark:"#445544",  price:0, unlocked:true },
  forest:  { id:"forest",  name:"Forest",   light:"#C8E6C9", dark:"#2E7D32", selected:"#FFD54F", lastLight:"#A5D6A7", lastDark:"#1B5E20",  price:0, unlockedBy:"games_10",   unlockedByName:"Initiate" },
  walnut:  { id:"walnut",  name:"Walnut",   light:"#D7CCC8", dark:"#4E342E", selected:"#F9A825", lastLight:"#BCAAA4", lastDark:"#3E2723",  price:0, unlockedBy:"first_win",  unlockedByName:"First Blood" },
  sunset:  { id:"sunset",  name:"Sunset",   light:"#FFCCBC", dark:"#BF360C", selected:"#FFF176", lastLight:"#FFAB91", lastDark:"#870000",  price:149 },
  ice:     { id:"ice",     name:"Ice",      light:"#E3F2FD", dark:"#1565C0", selected:"#FFF9C4", lastLight:"#BBDEFB", lastDark:"#0D47A1",  price:149 },
  royal:   { id:"royal",   name:"Royal",    light:"#EDE7F6", dark:"#512DA8", selected:"#FFF176", lastLight:"#D1C4E9", lastDark:"#4527A0",  price:0, unlockedBy:"bot_slayer", unlockedByName:"Slayer of Engines" },
  copper:  { id:"copper",  name:"Copper",   light:"#FBE9E7", dark:"#6D4C41", selected:"#F9A825", lastLight:"#FFCCBC", lastDark:"#4E342E",  price:149 },
  obsidian:{ id:"obsidian",name:"Obsidian", light:"#37303A", dark:"#1A1320", selected:"#7C6FE0", lastLight:"#4D4057", lastDark:"#2A2030",  price:199 },
  sand:    { id:"sand",    name:"Sand",     light:"#F5E6CA", dark:"#C2975A", selected:"#A5D6A7", lastLight:"#EDD9B0", lastDark:"#A07840",  price:149 },
};

// ─────────────────────────────────────────
//  PIECE PALETTES  (light shade vs dark shade of the same colour family)
//  Both players can buy the same pack — they'll still read as distinct
// ─────────────────────────────────────────

export const PIECE_PALETTES = [
  {
    id:"classic",    name:"Classic",
    desc:"Ivory & Obsidian",
    light:"#F0EEF8",  dark:"#1C1A2E",
    price:0, unlocked:true,
  },
  {
    id:"parchment",  name:"Parchment",
    desc:"Aged Cream & Walnut",
    light:"#EDE0C4",  dark:"#3D2B1F",
    price:0, unlockedBy:"first_win", unlockedByName:"First Blood",
  },
  {
    id:"silver",     name:"Silver & Steel",
    desc:"Polished Silver & Dark Iron",
    light:"#D8D8D8",  dark:"#383838",
    price:0, unlockedBy:"games_10", unlockedByName:"Initiate",
  },
  {
    id:"gold",       name:"Gold & Bronze",
    desc:"Pale Gold & Dark Bronze",
    light:"#FFE066",  dark:"#7B4F00",
    price:0, unlockedBy:"beat_easy", unlockedByName:"Warm Up",
  },
  {
    id:"jade",       name:"Jade",
    desc:"Pale Jade & Malachite",
    light:"#A8E6CF",  dark:"#004D40",
    price:0, unlockedBy:"bot_slayer", unlockedByName:"Slayer of Engines",
  },
  {
    id:"crimson",    name:"Crimson",
    desc:"Rose & Blood Red",
    light:"#FF8FA3",  dark:"#8B0000",
    price:149,
  },
  {
    id:"sapphire",   name:"Sapphire",
    desc:"Sky Blue & Deep Navy",
    light:"#87CEEB",  dark:"#1B2A7B",
    price:149,
  },
  {
    id:"emerald",    name:"Emerald",
    desc:"Mint & Forest Green",
    light:"#90EE90",  dark:"#1B5E20",
    price:149,
  },
  {
    id:"amber",      name:"Amber",
    desc:"Pale Amber & Burnt Sienna",
    light:"#FFD180",  dark:"#BF360C",
    price:149,
  },
  {
    id:"amethyst",   name:"Amethyst",
    desc:"Lavender & Deep Violet",
    light:"#D7B4F8",  dark:"#4A148C",
    price:199,
  },
  {
    id:"copper",     name:"Copper",
    desc:"Bright Copper & Dark Rust",
    light:"#FFB085",  dark:"#7B3F00",
    price:149,
  },
  {
    id:"arctic",     name:"Arctic",
    desc:"Glacier Ice & Deep Teal",
    light:"#E0F7FA",  dark:"#006064",
    price:199,
  },
  {
    id:"neon",       name:"Neon",
    desc:"Cyan & Magenta",
    light:"#00FFFF",  dark:"#FF00FF",
    price:249,
  },
  {
    id:"fire",       name:"Fire",
    desc:"Pale Ember & Deep Flame",
    light:"#FFB347",  dark:"#C0392B",
    price:199,
  },
  {
    id:"obsidian",   name:"Obsidian",
    desc:"Warm White & Volcanic Black",
    light:"#F5F0E8",  dark:"#1A1210",
    price:199,
  },
];

// ─────────────────────────────────────────
//  PIECE DESIGNS  (rendering / visual style)
//  getStyle(isWhite, palette) → CSS style object
// ─────────────────────────────────────────

export const PIECE_DESIGNS = [
  {
    id:"classic",
    name:"Classic",
    desc:"Standard filled pieces",
    price:0, unlocked:true,
    getStyle:(isWhite, pal) => ({
      color: isWhite ? pal.light : pal.dark,
      textShadow:`0 1px 4px rgba(0,0,0,0.55)`,
    }),
  },
  {
    id:"carved",
    name:"Carved",
    desc:"Heavy inset shadow, bold",
    price:0, unlockedBy:"first_win", unlockedByName:"First Blood",
    getStyle:(isWhite, pal) => ({
      color: isWhite ? pal.light : pal.dark,
      textShadow: isWhite
        ? `0 2px 0 rgba(0,0,0,0.7), 0 0 12px rgba(0,0,0,0.3)`
        : `0 2px 0 rgba(255,255,255,0.06), 0 0 12px rgba(0,0,0,0.7)`,
      filter:"contrast(1.15) brightness(1.05)",
    }),
  },
  {
    id:"phantom",
    name:"Phantom",
    desc:"Outlined hollow — no fill",
    price:199,
    getStyle:(isWhite, pal) => ({
      color:"transparent",
      WebkitTextStroke:`1.5px ${isWhite ? pal.light : pal.dark}`,
      textShadow:"none",
    }),
  },
  {
    id:"glow",
    name:"Radiant",
    desc:"Soft aura glow",
    price:249,
    getStyle:(isWhite, pal) => {
      const c = isWhite ? pal.light : pal.dark;
      return {
        color: c,
        textShadow:`0 0 10px ${c}, 0 0 22px ${c}80, 0 1px 3px rgba(0,0,0,0.5)`,
      };
    },
  },
  {
    id:"embossed",
    name:"Embossed",
    desc:"Raised 3-D relief",
    price:149,
    getStyle:(isWhite, pal) => ({
      color: isWhite ? pal.light : pal.dark,
      textShadow: isWhite
        ? `1px 1px 0 rgba(0,0,0,0.55), -1px -1px 0 rgba(255,255,255,0.12), 0 3px 6px rgba(0,0,0,0.4)`
        : `-1px -1px 0 rgba(255,255,255,0.06), 1px 1px 0 rgba(0,0,0,0.6), 0 3px 6px rgba(0,0,0,0.7)`,
    }),
  },
  {
    id:"shadow",
    name:"Shadow",
    desc:"Dramatic drop shadow",
    price:149,
    getStyle:(isWhite, pal) => ({
      color: isWhite ? pal.light : pal.dark,
      filter:`drop-shadow(3px 5px 6px rgba(0,0,0,0.8))`,
      textShadow:"none",
    }),
  },

  // ── Premium originals ────────────────────────────────────────────────────────

  {
    // White-hot forged metal: blazing core cools to deep crimson at the edges.
    // Dark: charcoal steel shell with an ember trapped inside.
    id:"inferno",
    name:"Inferno",
    desc:"White-hot forged metal — heat gradient from core to edge",
    price:699,
    getStyle:(isWhite) => isWhite ? {
      background:"linear-gradient(168deg, #FFFFFF 0%, #FFF5C0 12%, #FFD700 26%, #FF7700 46%, #CC1500 66%, #4A0800 100%)",
      WebkitBackgroundClip:"text",
      WebkitTextFillColor:"transparent",
      backgroundClip:"text",
      filter:"drop-shadow(0 0 3px rgba(255,230,100,0.9)) drop-shadow(0 0 10px rgba(255,110,0,0.65)) drop-shadow(0 4px 8px rgba(0,0,0,0.95))",
    } : {
      background:"linear-gradient(168deg, #0E0400 0%, #3D1000 22%, #8C2A00 42%, #D44A00 56%, #8C2A00 72%, #1A0600 100%)",
      WebkitBackgroundClip:"text",
      WebkitTextFillColor:"transparent",
      backgroundClip:"text",
      filter:"drop-shadow(0 0 5px rgba(210,60,0,0.95)) drop-shadow(0 0 14px rgba(160,20,0,0.6)) drop-shadow(0 5px 9px rgba(0,0,0,1))",
    },
  },

  {
    // Precise spectral dispersion through cut crystal: soft pastels on light,
    // deep saturated jewel tones on dark.
    id:"prism",
    name:"Prism",
    desc:"Cut-crystal light dispersion — full spectrum, light & dark variants",
    price:599,
    getStyle:(isWhite) => isWhite ? {
      background:"linear-gradient(112deg, #FFB3C6 0%, #FFD9A0 17%, #FEFFA0 33%, #AAEFAA 50%, #A0DAFF 67%, #C4AAFF 83%, #FFB3CC 100%)",
      WebkitBackgroundClip:"text",
      WebkitTextFillColor:"transparent",
      backgroundClip:"text",
      filter:"drop-shadow(0 0 4px rgba(220,230,255,0.85)) drop-shadow(0 0 12px rgba(180,200,255,0.45)) drop-shadow(0 3px 6px rgba(0,0,0,0.65))",
    } : {
      background:"linear-gradient(112deg, #BB0044 0%, #AA5500 17%, #777700 33%, #006633 50%, #0044BB 67%, #550099 83%, #990044 100%)",
      WebkitBackgroundClip:"text",
      WebkitTextFillColor:"transparent",
      backgroundClip:"text",
      filter:"drop-shadow(0 0 6px rgba(160,80,255,0.75)) drop-shadow(0 0 16px rgba(80,0,200,0.4)) drop-shadow(0 4px 7px rgba(0,0,0,0.95))",
    },
  },

  {
    // Semi-transparent fill with an upward inner glow — pieces look weightless,
    // hovering above the board. Heavy dropped shadow anchors them below.
    id:"specter",
    name:"Specter",
    desc:"Hovering apparition — translucent fill, deep float shadow",
    price:499,
    getStyle:(isWhite, pal) => {
      const c = isWhite ? pal.light : pal.dark;
      return {
        color:`${c}70`,
        WebkitTextStroke:`0.75px ${c}BB`,
        textShadow:`0 -4px 10px ${c}44, 0 -2px 5px ${c}33`,
        filter:`drop-shadow(0 10px 18px rgba(0,0,0,0.95)) drop-shadow(0 5px 8px rgba(0,0,0,0.7))`,
      };
    },
  },

  {
    // Light pieces: polished gold plate with specular highlight at crown.
    // Dark pieces: jet black with gold-trim catch-light top and bottom.
    id:"gilded",
    name:"Gilded",
    desc:"Gold-plated luxury — bright plate on light, jet & gold on dark",
    price:399,
    getStyle:(isWhite) => isWhite ? {
      background:"linear-gradient(172deg, #FFFDE0 0%, #FFE566 14%, #FFD700 34%, #C8950A 56%, #8B6510 76%, #4A3800 100%)",
      WebkitBackgroundClip:"text",
      WebkitTextFillColor:"transparent",
      backgroundClip:"text",
      filter:"drop-shadow(0 1px 0 rgba(255,245,160,0.5)) drop-shadow(0 3px 1px rgba(0,0,0,0.85)) drop-shadow(0 0 9px rgba(215,165,0,0.45))",
    } : {
      background:"linear-gradient(172deg, #C8A000 0%, #1C1200 10%, #080500 38%, #0F0900 65%, #1C1200 88%, #C8A000 100%)",
      WebkitBackgroundClip:"text",
      WebkitTextFillColor:"transparent",
      backgroundClip:"text",
      filter:"drop-shadow(0 1px 0 rgba(180,130,0,0.4)) drop-shadow(0 3px 1px rgba(0,0,0,0.95)) drop-shadow(0 0 7px rgba(130,90,0,0.35))",
    },
  },
];

// Resolve the final CSS style for a piece
export function getPieceStyle(designId, paletteId, isWhite) {
  const palette = PIECE_PALETTES.find(p => p.id === paletteId) || PIECE_PALETTES[0];
  const design  = PIECE_DESIGNS.find(d => d.id === designId)   || PIECE_DESIGNS[0];
  return design.getStyle(isWhite, palette);
}

// ─────────────────────────────────────────
//  PREFS
// ─────────────────────────────────────────

export const DEFAULT_PREFS = {
  theme:       "classic",
  pieceColor:  "classic",
  pieceDesign: "classic",
  boardSize:   "standard",  // "compact" | "standard" | "large"
  fontScale:   1.0,         // 0.85 | 1.0 | 1.15
  orientation: "auto",      // "auto" | "landscape" | "portrait"
  sfxOn:        true,
  sfxVol:       0.7,
  ambientOn:    false,
  ambientVol:   0.32,
  ambientSong: 0,
  activeCosmeticPieces: null, // crown cosmetic piece set ID (overrides pieceDesign/Color)
  activeCosmeticBoard:  null, // crown cosmetic board ID (overrides theme)
};

export function loadPrefs() {
  try {
    const raw = localStorage.getItem("checkmate_prefs");
    if (!raw) return { ...DEFAULT_PREFS };
    return { ...DEFAULT_PREFS, ...JSON.parse(raw) };
  } catch {
    return { ...DEFAULT_PREFS };
  }
}

export function savePrefs(prefs) {
  try { localStorage.setItem("checkmate_prefs", JSON.stringify(prefs)); } catch {}
}

// purchasedItemIds: array of item IDs bought via Stripe or granted via monthly drop
export function isUnlocked(item, earnedTrophyIds, purchasedItemIds = []) {
  if (item.unlocked) return true;
  if (item.unlockedBy && earnedTrophyIds.includes(item.unlockedBy)) return true;
  if (purchasedItemIds.includes(item.id)) return true;
  return false;
}

// All items that can appear in the daily shop rotation (paid, no trophy unlock)
export function getShopPool() {
  const boards  = Object.values(BOARD_THEMES).filter(i => i.price > 0 && !i.unlockedBy);
  const palettes = PIECE_PALETTES.filter(i => i.price > 0 && !i.unlockedBy);
  const designs  = PIECE_DESIGNS.filter(i => i.price > 0 && !i.unlockedBy);
  return [
    ...boards.map(i  => ({ ...i, category: "board" })),
    ...palettes.map(i => ({ ...i, category: "palette" })),
    ...designs.map(i  => ({ ...i, category: "design" })),
  ];
}

// Seeded daily rotation — deterministic from today's date
export function getDailyRotation(count = 5) {
  const d = new Date();
  const dateStr = `${d.getFullYear()}-${d.getMonth()}-${d.getDate()}`;
  let seed = 0;
  for (let i = 0; i < dateStr.length; i++) {
    seed = Math.imul(31, seed) + dateStr.charCodeAt(i) | 0;
  }
  const rand = () => {
    seed = Math.imul(48271, seed) | 0;
    return (seed >>> 0) / 0xFFFFFFFF;
  };
  const pool = getShopPool();
  const shuffled = [...pool];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(rand() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled.slice(0, count);
}
